import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


// initial state
const state = {
    StoreID: 0,
    StoreName: "",
    selectArea: 0,
    StoreType:0,
}

// getters
const getters = {
    // 获取用户信息
    getState() {
        return state;
    }
}

// actions
const actions = {}

// mutations
const mutations = {
    setState(state, newstate) {
        state.StoreID = newstate.StoreID;
        state.StoreName = newstate.StoreName;
        state.selectArea = newstate.selectArea;
        state.StoreType=newstate.StoreType;

    }
}
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js